import React, { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { BrowserRouter } from "react-router-dom";
import App from "../App";
import { Provider } from "react-redux";

import { getShowtimeInfo } from "../store/globals";

const MiddlewareRecaptcha = ({
  store,
  cinemaVistaId,
  showtimeVistaId,
  appWasRendered,
}) => {
  //const recaptchaRef = useRef(null)
  const [renderProvider, setRenderProvider] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!appWasRendered) {
      getShowtimeInfo(store.dispatch, cinemaVistaId, showtimeVistaId).then(() =>
        setRenderProvider(true)
      );
    }
  }, []);

  const getToken = () => {
    //const tokenG = recaptchaRef.current.getValue();
    //if(tokenG !== ""){
    getShowtimeInfo(store.dispatch, cinemaVistaId, showtimeVistaId).then(() =>
      setRenderProvider(true)
    );
    //}
  };

  return (
    <>
      {loading && (
        <div className="loading-app">
          <figure className="loading-app__img">
            <img src="./cine-yelmo.png" alt="Cinépolis®" />
          </figure>
          <p className="loading-app__text">Cargando...</p>
        </div>
      )}

      {(renderProvider || appWasRendered) && (
        <Provider store={store}>
          <BrowserRouter>
            <App setLoading={setLoading} />
          </BrowserRouter>
        </Provider>
      )}

      <ReCAPTCHA
        //ref={recaptchaRef}
        size="invisible"
        sitekey="6LcVRncgAAAAAIki4zbiiTYFCUNkbrcLAyqqxOhi"
        onChange={getToken}
      />
    </>
  );
};

export default MiddlewareRecaptcha;
